module.exports = __webpack_public_path__ + "static/img/郭振宇董事长4.28385416.png";